const TOASTER_TYPE = {
    SUCCESS: "success",
    DANGER: "danger"
};

export default TOASTER_TYPE;
